import { makeAutoObservable, action, computed } from 'mobx';

class StudioStore {
  settings = {
    fonts: {
      primary_font: '',
      secondary_font: '',
      special_font: '',
    },
    products: {},
    cart: {},
    colors: {},
    product_popup: {},
    checkout_page: {},
  };

  constructor() {
    makeAutoObservable(this, {
      setSettings: action,
      setPrimaryFont: action,
      setSecondaryFont: action,
      setSpecialFont: action,
      products: computed,
      cart: computed,
      colors: computed,
      fonts: computed,
      product_popup: computed,
      checkout_page: computed,
    });
  }

  setSettings(newSettings) {
    this.settings = {
      ...this.settings,
      ...newSettings,
    };
  }

  setPrimaryFont(fontName) {
    this.settings.fonts.primary_font = fontName;
  }

  setSecondaryFont(fontName) {
    this.settings.fonts.secondary_font = fontName;
  }

  setSpecialFont(fontName) {
    this.settings.fonts.special_font = fontName;
  }

  getSettings(id) {
    return this.settings[id] || '';
  }

  getPrimaryFont() {
    return this.settings.fonts.primary_font || '';
  }

  getSecondaryFont() {
    return this.settings.fonts.secondary_font || '';
  }

  getSpecialFont() {
    return this.settings.fonts.special_font || '';
  }

  get products() {
    return this.getSettings('products');
  }

  get cart() {
    return this.getSettings('cart');
  }

  get colors() {
    return this.getSettings('colors');
  }

  get fonts() {
    return this.getSettings('fonts');
  }

  get product_popup() {
    return this.getSettings('product_popup');
  }

  get checkout_page() {
    return this.getSettings('checkout_page');
  }
}

const studioStore = new StudioStore();
export default studioStore;